import React, { useState, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Snackbar as Snackbar$1, Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { IconButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
const useStyles = makeStyles()((theme) => ({
  snackbarContent: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary
  },
  snackbarTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexDirection: "row"
  },
  snackbarAction: {
    margin: theme.spacing(1)
  }
}));
const localized = defineMessages({
  snackbarCountdown: {
    id: "snackbarCountdown",
    defaultMessage: " in {seconds} seconds"
  }
});
function Snackbar({
  open,
  message,
  action,
  onAction,
  onClose,
  messageIcon,
  autoHideDuration,
  showCountDown,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  ...props
}) {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();
  const millisecondsInSecond = 1e3;
  const autoHideDurationSeconds = autoHideDuration > 0 ? autoHideDuration / millisecondsInSecond : null;
  const [secondsRemaining, setSecondsRemaining] = useState(autoHideDurationSeconds);
  useEffect(() => {
    const interval = setInterval(() => {
      if (secondsRemaining > 0) {
        setSecondsRemaining((secondsRemaining2) => secondsRemaining2 - 1);
      } else {
        clearInterval(interval);
      }
    }, millisecondsInSecond);
    return () => clearInterval(interval);
  }, []);
  function getAction() {
    let res = null;
    if (action && typeof action === "string") {
      res = /* @__PURE__ */ React.createElement(LinkText, { underline: "none", onClick: handleAction, title: action, className: classes.snackbarAction });
    } else if (action) {
      res = /* @__PURE__ */ React.createElement(React.Fragment, null, action);
    }
    return res;
  }
  function getSecondsRemaining() {
    return showCountDown === true && secondsRemaining >= 0 ? formatMessage(localized.snackbarCountdown, { seconds: secondsRemaining }) : null;
  }
  function handleClose(e, reason) {
    e?.stopPropagation();
    if (onClose) {
      onClose(e, reason);
    }
  }
  function handleAction(e) {
    e.stopPropagation();
    if (onAction) {
      onAction();
    }
  }
  return /* @__PURE__ */ React.createElement(
    Snackbar$1,
    {
      open,
      autoHideDuration,
      anchorOrigin,
      message: /* @__PURE__ */ React.createElement(Box, { className: classes.snackbarTitle }, messageIcon ? messageIcon : null, typeof message === "string" ? /* @__PURE__ */ React.createElement(Typography, { variant: "body1", component: "span" }, message, getSecondsRemaining()) : /* @__PURE__ */ React.createElement(Box, null, message, getSecondsRemaining())),
      action: /* @__PURE__ */ React.createElement(React.Fragment, null, getAction(), /* @__PURE__ */ React.createElement(IconButton, { iconClassName: CustomIcon.CancelOutline, onClick: (e) => handleClose(e, "clickClose") })),
      ContentProps: { className: classes.snackbarContent },
      onClose: handleClose,
      ...props
    }
  );
}
export {
  Snackbar,
  useStyles
};
//# sourceMappingURL=Snackbar.js.map
